import { frontendURL } from '../../../helper/URLHelper';
import ProductsIndex from './pages/ProductsIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.PROPOSAL_MANAGEMENT,
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/products'),
    component: ProductsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'products_dashboard_index',
        component: ProductsIndex,
        meta: commonMeta,
      },
    ],
  },
];
